import { MONTHS_PER_YEAR } from '@pretto/bricks/core/constants'
import { roundNumber } from '@pretto/bricks/core/utility/formatters'

import orderBy from 'lodash/orderBy'
import range from 'lodash/range'

import { duration } from '../config/inputs'
import { INDEBTEDNESS_RATE } from '../config/static'

import * as calc from './calc'

const NUMBER_STEPS = 5
const { min: MIN_DURATION, max: MAX_DURATION } = duration

export const getDefaultIncome = loanAmount => {
  if (!loanAmount || loanAmount < 300000) return 4000

  if (loanAmount < 600000) return 7000

  return 10000
}

export const getError = ({ payment, income, numberMortgagors }) => {
  if (income === 0) {
    return 'noIncome'
  }

  const indebtednessRate = payment / income > INDEBTEDNESS_RATE && 'indebtednessRate'

  const rla =
    ((parseInt(numberMortgagors) === 1 && income - payment < 700) ||
      (parseInt(numberMortgagors) === 2 && income - payment < 1200)) &&
    'rla'

  const error = [indebtednessRate, rla].filter(Boolean).join('_')

  return error
}

export const filterGraphResults = ({ income, duration, miniSimulator, numberMortgagors }) => {
  const resultsGraph = miniSimulator.results.reduce((previous, data) => {
    const previousDurations = previous.map(({ duration }) => duration)

    if (previousDurations.includes(data.duration)) {
      return previous
    }

    const maxSalary = getMaxSalary(miniSimulator)
    const computedIncome = income > maxSalary ? maxSalary : income

    if (
      [10, 15, 20, 25, parseInt(duration)].includes(data.duration) &&
      computedIncome >= data.salary_min &&
      computedIncome <= data.salary_max &&
      parseInt(numberMortgagors) === data.nb_mortgagors
    ) {
      return [...previous, data]
    }

    return previous
  }, [])

  return orderBy(resultsGraph, 'duration')
}

export const formatBars = ({ selectedDuration, results, loanAmount }) =>
  results.map(({ duration, rate }) => {
    const payment = calc.payment({ duration, loanAmount, rate })
    const interests = calc.creditCost({ duration, loanAmount, payment })
    const monthlyInterests = interests / (duration * MONTHS_PER_YEAR)

    return {
      duration,
      isActive: selectedDuration === duration,
      principal: payment,
      totalCost: interests,
      totalPayment: payment + monthlyInterests,
    }
  })

export const getSteps = (elements, key, round) => {
  const max = roundNumber(
    elements.reduce((previous, current) => {
      const value = current[key]
      if (value > previous) return value
      return previous
    }, 0),
    round,
    Math.ceil
  )

  const step = max / NUMBER_STEPS
  const steps = range(0, max + 1, step).reverse()
  return steps
}

export const getMaxSalary = miniSimulator =>
  miniSimulator.results.reduce((previous, { salary_max }) => {
    if (salary_max > previous) return salary_max
    return previous
  }, 0)

export const getMatch = ({ duration, income, miniSimulator, numberMortgagors }) => {
  const maxSalary = getMaxSalary(miniSimulator)
  const computedIncome = income > maxSalary ? maxSalary : income
  const computedDuration =
    duration < MIN_DURATION ? MIN_DURATION : duration > MAX_DURATION ? MAX_DURATION : Math.round(duration)

  const match = miniSimulator.results.find(data => {
    return (
      data.duration === computedDuration &&
      computedIncome >= data.salary_min &&
      computedIncome <= data.salary_max &&
      parseInt(numberMortgagors) === data.nb_mortgagors
    )
  })

  return match
}
